import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import { CurrencyTD, Td, Tr } from "commons";

export class RegularTableRow extends PureComponent {
    static formatSort(sortCode) {
        if (sortCode !== undefined) {
            return sortCode.split(/(?=(?:..)*$)/).join("-");
        } else {
            return "";
        }
    }

    render() {
        return (
            <Tr>
                <Td>{this.props.type}</Td>
                <CurrencyTD amount={this.props.amount} align="left" />
                <Td>{this.props.frequency}</Td>
                <Td>{this.props.next}</Td>
                <Td>
                    {RegularTableRow.formatSort(this.props.bankSortCode)} /{" "}
                    {this.props.bankAccountNumber}
                </Td>
            </Tr>
        );
    }
}

RegularTableRow.propTypes = {
    type: PropTypes.string,
    amount: PropTypes.number,
    frequency: PropTypes.string,
    next: PropTypes.string,
    bankSortCode: PropTypes.string,
    bankAccountNumber: PropTypes.string
};
